import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useGetGeneratorsById = (
  generatorIds: Array<Readonly<[string]> | Readonly<[string, string]>>,
) => {
  const { data: generators, isFetching: isFetchingGenerators } = useQuery({
    queryKey: ['generators-by-id', generatorIds.join('-')],
    queryFn: async () => {
      const generators = await backendService.instance.generators.listByIds(generatorIds);
      return generators;
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    generators,
    isFetchingGenerators,
  };
};

export const useGetGeneratorsByIdV2 = (generatorIds: Array<Readonly<string>>) => {
  const { data: generators, isFetching: isFetchingGenerators } = useQuery({
    queryKey: ['generators-by-id-v2', generatorIds.join(';')],
    queryFn: async () => {
      const generators = await backendService.instance.generators.listByIdsV2(
        generatorIds.map(splitGeneratorId),
      );
      return generators;
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    generators,
    isFetchingGenerators,
  };
};

function splitGeneratorId(generatorId: string): [string, string] | [string] {
  const [templateId, variantId] = generatorId.split('::');
  if (variantId) {
    return [templateId, variantId];
  }
  return [templateId];
}
